// Przestrzeń nazw 'outbound': sekcja „Połączenia wychodzące" (kampanie, numery do dzwonienia,
// import CSV, scenariusze, historia rozmów, sprzedawcy) i przełącznik dostępności w nagłówku.
//
// VERIFY: cały plik. Mockup (design/voicesphere-dashboard.html) nie ma tej sekcji.
// Klucze statusów, wyników, kodów i dni to wartości z API (kontrakt), tłumaczone są tylko
// etykiety. Bloki `activity`, `refusal`, `entryError`, `importError`, `skipReason`,
// `phoneProblem` i `fieldError` to polskie wersje znanych zdań, które API zwraca po angielsku
// (dopasowanie w `outbound-calls.messages.ts`); zdanie spoza listy pokazujemy bez zmian.
export default {
  tabs: {
    campaigns: 'Kampanie',
    scenarios: 'Scenariusze',
    calls: 'Historia rozmów',
    salespeople: 'Sprzedawcy',
  },
  pickCompany: 'Wybierz firmę, aby zobaczyć połączenia wychodzące.',
  actionFailed: 'Operacja się nie powiodła',
  saved: 'Zapisano',
  none: '—',
  refreshing: 'Odświeżane co {{seconds}} s',

  errors: {
    load: 'Nie udało się pobrać danych. Odśwież stronę, aby spróbować ponownie.',
    notPermitted: 'Nie masz uprawnień do zarządzania połączeniami wychodzącymi.',
    companyNotFound: 'Nie znaleziono firmy albo nie masz do niej dostępu.',
    campaignNotFound: 'Nie znaleziono kampanii.',
    leadNotFound: 'Nie znaleziono firmy z listy.',
    callNotFound: 'Nie znaleziono rozmowy.',
    scenarioNotFound: 'Nie znaleziono scenariusza.',
    salespersonNotFound: 'Nie znaleziono sprzedawcy.',
  },

  campaignStatus: {
    draft: 'Szkic',
    running: 'Trwa',
    paused: 'Wstrzymana',
    finished: 'Zakończona',
  },
  entryStatus: {
    pending: 'Do zadzwonienia',
    callback: 'Oddzwonienie',
    calling: 'Dzwonię',
    reached: 'Dodzwoniono',
    not_reached: 'Nie dodzwoniono',
    failed: 'Błąd',
    skipped: 'Pominięto',
  },
  disposition: {
    reached: 'Rozmowa',
    voicemail: 'Poczta głosowa',
    wrong_person: 'Niewłaściwa osoba',
    refused: 'Odmowa',
    unresponsive: 'Brak reakcji',
    incomplete: 'Przerwana',
    no_answer: 'Nie odebrano',
    busy: 'Zajęte',
    failed: 'Błąd połączenia',
  },
  // Kod, od którego agent zaczyna `conclusion`.
  conclusion: {
    not_interested: 'Niezainteresowany',
    no_budget: 'Brak budżetu',
    has_provider: 'Ma już dostawcę',
    not_decision_maker: 'Nie decyduje',
    gatekeeper_blocked: 'Sekretariat nie połączył',
    call_back_later: 'Oddzwonić później',
    send_offer_by_email: 'Prosi o informacje e-mailem',
    do_not_call: 'Nie dzwonić więcej',
    salesperson_no_answer: 'Sprzedawca nie odebrał',
    salesperson_unavailable: 'Brak dostępnego sprzedawcy',
    expert_requested: 'Chce rozmawiać z ekspertem',
    transferred_to_expert: 'Przekazano do eksperta',
  },
  transferResult: {
    connected: 'Połączono ze sprzedawcą',
    no_answer: 'Sprzedawca nie odebrał',
    unavailable: 'Brak dostępnego sprzedawcy',
    failed: 'Przekazanie nie powiodło się',
  },
  objective: {
    completed: 'Cel osiągnięty',
    notCompleted: 'Cel nieosiągnięty',
  },
  triggerSource: {
    crm_panel: 'Panel',
    api: 'API',
    notification: 'Powiadomienie',
    campaign: 'Kampania',
  },
  salesAgentStatus: {
    offline: 'Niedostępny',
    available: 'Dostępny',
    busy: 'W rozmowie',
  },
  // Klucze to dni ISO z API (poniedziałek = 1).
  weekdays: {
    '1': 'Pn',
    '2': 'Wt',
    '3': 'Śr',
    '4': 'Cz',
    '5': 'Pt',
    '6': 'So',
    '7': 'Nd',
  },

  // `activity` kampanii.
  activity: {
    notStarted: 'Nie wystartowała.',
    paused: 'Wstrzymana. Wznów ją, aby dzwonić dalej.',
    finished: 'Zakończona.',
    dialling: 'Następny numer w ciągu minuty.',
    finishing: 'Nie ma już do kogo dzwonić. Kampania zakończy się w ciągu minuty.',
    noSalesperson: 'Czeka: żaden sprzedawca nie jest dostępny.',
    windowOpens: 'Czeka: poza oknem dzwonienia, otwiera się {{day}} o {{time}}.',
    outsideWindow: 'Czeka: poza oknem dzwonienia.',
    onTheAir: 'Czeka: trwa rozmowa z numerem {{phone}}.',
    otherCampaignCall: 'Czeka: trwa rozmowa z numerem {{phone}} z kampanii {{campaign}}.',
    pause: 'Czeka: przerwa między rozmowami do {{time}}.',
    retryDue: 'Czeka: następna próba {{day}} o {{time}}.',
    callbackDue: 'Czeka: następne oddzwonienie {{day}} o {{time}}.',
  },
  // Odmowy akcji (`code: campaign_refused`) i `last_error` kampanii.
  refusal: {
    onlyDraftStarts: 'Wystartować można tylko kampanię w szkicu.',
    nothingToCall: 'Kampania nie ma do kogo dzwonić. Najpierw zaimportuj listę.',
    scenarioInactive: 'Scenariusz kampanii jest wyłączony.',
    noOutgoingPhone: 'Firma nie ma ustawionego numeru do połączeń wychodzących.',
    languageNotSupported: 'Nieobsługiwany język rozmowy: {{language}}.',
    anotherRunning: 'Inna kampania tej firmy już trwa.',
    wrongStatus: 'Kampania ma status „{{status}}”, a ta akcja wymaga statusu „{{expected}}”.',
    finishedImport: 'Kampania jest zakończona. Utwórz nową dla tej listy.',
    failuresInARow: 'Kolejne nieudane połączenia: {{failures}}. Ostatni błąd: {{error}}',
    callbackBlocked:
      'Oddzwonienie wypada {{when}}, ale trwa inna kampania tej firmy. Wznów tę, aby zadzwonić.',
  },
  // `last_error` wpisu.
  entryError: {
    doNotCall: 'Numer na liście „nie dzwonić”.',
    wrongNumber: 'Zły numer, odebrał ktoś inny. Do weryfikacji.',
    callbackNotBooked: 'Nie umówiono oddzwonienia na {{when}}: {{reason}}.',
    onDoNotCallList: 'numer jest na liście „nie dzwonić”',
    reachedSomeoneElse: 'pod tym numerem odebrał ktoś inny',
    callbackLimit: 'kampania pozwala na {{max}} oddzwonienia na numer',
    timePassed: 'termin już minął',
    tooFarAhead: 'to więcej niż {{days}} dni naprzód',
    noCallingDay: 'kampania nie ma dni dzwonienia',
  },
  // Błędy pliku z importu (`errors.file`).
  importError: {
    noFile: 'Nie wybrano pliku.',
    empty: 'Plik jest pusty.',
    tooLarge: 'Plik jest większy niż {{size}} MB.',
    notUtf8: 'Plik nie jest zapisany w UTF-8. W Excelu zapisz go jako „CSV UTF-8”.',
    missingColumn: 'Brakuje kolumny: {{column}}.',
    tooManyRows: 'Plik ma więcej niż {{max}} wierszy. Podziel go na pliki po {{max}} wierszy.',
  },
  // Powody pominięcia wiersza w raporcie importu.
  skipReason: {
    missingName: 'brak nazwy firmy',
    invalidNip: 'nieprawidłowy NIP: {{nip}}',
    contactWithoutPhone: 'kontakt bez numeru telefonu',
    contactPhone: 'telefon kontaktu: {{problem}}',
    companyPhone: 'pominięto telefon firmy: {{problem}}',
    noPhone: '{{name}}: brak numeru telefonu',
    statusNote: 'oznaczona na liście jako „{{note}}”',
    lostLetters: 'eksport zgubił polskie litery w nazwie: {{name}}',
  },
  phoneProblem: {
    missing: 'brak numeru',
    notAPhone: 'to nie jest numer telefonu: {{raw}}',
    noCountryCode: 'brak numeru kierunkowego i to nie jest 9-cyfrowy numer polski: {{raw}}',
    polishLength: 'polski numer ma 9 cyfr po +48: {{raw}}',
    invalid: 'nieprawidłowy numer międzynarodowy: {{raw}}',
    onlyPlAndUs: 'dzwonimy tylko na numery +48 i +1: {{raw}}',
    summed: 'eksport zsumował kilka numerów w jeden: {{raw}}',
  },
  // Komunikaty 422 przy polach formularzy.
  fieldError: {
    required: 'To pole jest wymagane',
    taken: 'Ta wartość jest już zajęta',
    notCompanyScenario: 'To nie jest scenariusz tej firmy',
    scenarioInactive: 'Ten scenariusz jest wyłączony',
    noVoice: 'Firma nie ma głosu w tym języku',
    windowOrder: 'Koniec okna musi być po jego początku',
    pickDay: 'Wybierz co najmniej jeden dzień',
    alreadySalesperson: 'To konto jest już przypisane do innego sprzedawcy',
    notCompanyUser: 'To konto nie należy do tej firmy',
    bothHours: 'Podaj obie godziny albo żadnej',
    hoursOrder: 'Koniec musi być po początku',
    enterAs: 'Wpisz numer jako {{phone}}',
    max: 'Wartość nie może być większa niż {{max}}',
    min: 'Wartość nie może być mniejsza niż {{min}}',
    integer: 'Podaj liczbę całkowitą',
    maxLength: 'Najwyżej {{max}} znaków',
  },

  campaigns: {
    add: 'Nowa kampania',
    empty: 'Nie ma jeszcze kampanii.',
    emptyFiltered: 'Brak kampanii o tym statusie.',
    // The chips name groups of campaigns, where `campaignStatus` names one campaign's state.
    filters: {
      draft: 'Szkice',
      running: 'Trwające',
      paused: 'Wstrzymane',
      finished: 'Zakończone',
    },
    columns: {
      name: 'Kampania',
      status: 'Status',
      progress: 'Postęp',
      window: 'Okno dzwonienia',
      activity: 'Co się dzieje',
      startedAt: 'Start',
    },
    progress: '{{done}} z {{total}}',
    progressLabel: 'Postęp kampanii {{name}}',
    window: '{{start}}–{{end}}, {{days}}',
  },

  campaign: {
    back: 'Wszystkie kampanie',
    lastError: 'Ostatni błąd',
    scenarioInactive:
      'Scenariusz „{{name}}” jest wyłączony. Kampanii nie da się wystartować ani wznowić.',
    actions: {
      start: 'Start',
      pause: 'Wstrzymaj',
      resume: 'Wznów',
      retry_unreached: 'Ponów nieodebrane',
      edit: 'Edytuj',
      import: 'Importuj CSV',
      export: 'Eksportuj CSV',
    },
    actionDone: {
      start: 'Kampania wystartowała',
      pause: 'Kampania wstrzymana. Trwająca rozmowa dobiegnie końca.',
      resume: 'Kampania wznowiona',
    },
    retried_one: 'Do kolejki wrócił {{count}} numer.',
    retried_few: 'Do kolejki wróciły {{count}} numery.',
    retried_many: 'Do kolejki wróciło {{count}} numerów.',
    retried_other: 'Do kolejki wróciło {{count}} numeru.',
    retriedPaused: 'Kampania jest wstrzymana: wznów ją, aby zadzwonić.',
    retriedNone: 'Nie ma czego ponawiać: żaden numer nie jest nieodebrany ani z błędem.',
    exportFailed: 'Nie udało się wyeksportować numerów',
    kpi: {
      total: 'Numery',
      pending: 'Do zadzwonienia',
      callbacks: 'w tym oddzwonienia: {{callbacks}}',
      reached: 'Dodzwoniono',
      not_reached: 'Nie dodzwoniono',
      skipped: 'Pominięte i błędy',
    },
    settings: {
      scenario: 'Scenariusz',
      language: 'Język',
      window: 'Okno dzwonienia',
      attempts: 'Próby',
      attemptsValue: 'do {{max}}, co {{delay}} min',
      callbacks: 'Oddzwonienia na numer',
      pause: 'Pauza między rozmowami',
      pauseValue: '{{seconds}} s',
      openingLine: 'Otwarcie',
      openingLineScenario: 'ze scenariusza',
      createdBy: 'Utworzył',
    },
  },

  entries: {
    title: 'Numery do dzwonienia',
    searchPlaceholder: 'Szukaj firmy, NIP-u lub numeru',
    empty: 'Brak numerów spełniających kryteria.',
    switchboard: 'Numer firmy',
    doNotCall: 'Nie dzwonić',
    wrongNumber: 'Zły numer',
    callbackAt: 'oddzwonienie: {{at}}',
    callbacks: 'oddzwonienia: {{callbacks}}',
    nextAttempt: 'następna: {{at}}',
    columns: {
      lead: 'Firma',
      contact: 'Kontakt',
      phone: 'Numer',
      status: 'Status',
      attempts: 'Próby',
      lastAttempt: 'Ostatnia rozmowa',
      outcome: 'Wynik',
    },
  },

  campaignForm: {
    createTitle: 'Nowa kampania',
    createSubtitle: 'Kampania powstaje jako szkic. Numery dodasz importem CSV.',
    editTitle: 'Edytuj kampanię',
    editSubtitle: 'Zmiany działają od następnego połączenia.',
    fields: {
      name: 'Nazwa',
      scenario: 'Scenariusz',
      language: 'Język rozmowy',
      openingLine: 'Otwarcie',
      window: 'Okno dzwonienia',
      windowStart: 'Od',
      windowEnd: 'Do',
      callDays: 'Dni dzwonienia',
      maxAttempts: 'Maksymalna liczba prób',
      retryDelay: 'Odstęp między próbami (min)',
      retryOn: 'Ponawiaj, gdy',
      maxCallbacks: 'Oddzwonienia na numer',
      pause: 'Pauza między rozmowami (s)',
    },
    help: {
      openingLine:
        'Zastępuje otwarcie ze scenariusza. {firma} zostanie zastąpione nazwą firmy. Puste = otwarcie ze scenariusza.',
      window: 'Czas firmy. Poza oknem kampania czeka.',
      maxCallbacks: 'Ile razy rozmówca może poprosić o telefon w innym terminie. Nie zużywa prób.',
    },
    validation: {
      nameRequired: 'Podaj nazwę kampanii',
      scenarioRequired: 'Wybierz scenariusz',
      languageRequired: 'Wybierz język',
      windowRequired: 'Podaj godzinę',
      nameTaken: 'Kampania o tej nazwie już istnieje',
    },
    saveFailed: 'Nie udało się zapisać kampanii',
    noScenarios: 'Najpierw dodaj aktywny scenariusz.',
  },

  import: {
    title: 'Import listy firm',
    hint: 'Plik CSV (UTF-8, średnik albo przecinek): nasz szablon albo eksport z CRM z kolumnami „Nazwa firmy”, „Telefon służbowy” i „Telefon komórkowy”. Najpierw sprawdzimy plik, nic nie zapisując.',
    pickFile: 'Wybierz plik CSV',
    template: 'Pobierz szablon',
    templateFailed: 'Nie udało się pobrać szablonu',
    check: 'Sprawdź plik',
    confirm: 'Importuj',
    previewTitle: 'Po imporcie',
    leads: 'Firmy',
    contacts: 'Kontakty',
    entries: 'Nowe numery do dzwonienia',
    alreadyInCampaign: 'Już w kampanii',
    skippedTitle: 'Pominięte wiersze',
    skippedNone: 'Żaden wiersz nie został pominięty.',
    warningsTitle: 'Zaimportowane, do sprawdzenia',
    line: 'Wiersz',
    reason: 'Powód',
    outcome: 'Wynik',
    rowSkipped: 'pominięty',
    rowWarning: 'do sprawdzenia',
    downloadReport: 'Pobierz raport (CSV)',
    reportFileName: '{{name}}-raport.csv',
    // Sumy kilku numerów: Excel zapisał komórkę z telefonami jako liczbę.
    summedHint:
      'Część numerów to sumy kilku numerów: eksport zapisał kolumny telefonów jako liczby. Wyeksportuj je jako tekst i sprawdź plik jeszcze raz.',
    // Krótkie nazwy grup w podsumowaniu raportu, po kodzie z API.
    issues: {
      status_note: 'Oznaczone na liście (dubel, likwidacja…)',
      summed_numbers: 'Zsumowane numery',
      no_phone: 'Firmy bez numeru',
      company_phone: 'Błędny telefon firmy',
      contact_phone: 'Błędny telefon kontaktu',
      contact_without_phone: 'Kontakty bez telefonu',
      missing_name: 'Brak nazwy firmy',
      invalid_nip: 'Błędny NIP',
      invalid_value: 'Błędne wartości',
      lost_letters: 'Brak polskich liter w nazwie',
    },
    nothingToImport: 'Plik nie zawiera nowych numerów do dzwonienia.',
    done: 'Zaimportowano numery: {{entries}}',
    failed: 'Nie udało się przetworzyć pliku',
  },

  lead: {
    fallbackTitle: 'Firma',
    nip: 'NIP',
    industry: 'Branża',
    website: 'Strona www',
    email: 'E-mail',
    phone: 'Telefon',
    address: 'Adres',
    accountOwner: 'Opiekun',
    doNotCall: 'Nie dzwonić',
    doNotCallLead: 'Nie dzwonić do tej firmy',
    doNotCallLeadHint: 'Blokuje wszystkie numery firmy we wszystkich kampaniach.',
    doNotCallContact: 'Nie dzwonić do: {{name}}',
    wrongNumber: 'Zły numer',
    wrongNumberLead: 'Zły numer firmy',
    wrongNumberLeadHint:
      'Pomija tylko numer {{phone}}, kontakty zostają. Włącza się sam, gdy odbierze ktoś inny. Wyłącz po sprawdzeniu numeru.',
    wrongNumberContact: 'Zły numer: {{name}}',
    contacts: 'Kontakty',
    noContacts: 'Brak kontaktów, dzwonimy na numer firmy.',
    campaigns: 'Kampanie',
    attempts: 'Historia rozmów',
    noAttempts: 'Do tej firmy jeszcze nie dzwoniono.',
    attemptsCount: 'próby: {{attempts}}',
  },

  call: {
    title: 'Rozmowa {{phone}}',
    conclusion: 'Wnioski',
    extractedData: 'Zebrane dane',
    callDetails: 'Nagranie i transkrypcja',
    showLead: 'Szczegóły firmy',
    live: 'W toku',
    facts: {
      scenario: 'Scenariusz',
      campaign: 'Kampania',
      source: 'Źródło',
      duration: 'Czas rozmowy',
      language: 'Język',
      transfer: 'Przekazanie do sprzedawcy',
      transferredTo: 'Sprzedawca',
      transferAttempts: 'Próby przekazania',
      notTransferred: 'Nie przekazywano',
    },
  },

  scenarios: {
    add: 'Nowy scenariusz',
    empty: 'Nie ma jeszcze scenariuszy.',
    columns: {
      name: 'Scenariusz',
      objective: 'Cel',
      active: 'Aktywny',
      updatedAt: 'Zmieniony',
    },
    toggleActive: 'Aktywny: {{name}}',
    edit: 'Edytuj {{name}}',
    testCall: 'Rozmowa testowa: {{name}}',
    testCallInactive: 'Włącz scenariusz, aby zadzwonić',
  },

  scenarioForm: {
    createTitle: 'Nowy scenariusz',
    editTitle: 'Edytuj scenariusz',
    subtitle: 'Scenariusz mówi agentowi, po co dzwoni i czego mu nie wolno.',
    fields: {
      name: 'Nazwa',
      objective: 'Cel rozmowy',
      successCriteria: 'Kryterium sukcesu',
      openingLine: 'Otwarcie',
      guardrails: 'Zasady (guardrails)',
      dataToCollect: 'Dane do zebrania',
      dataKey: 'Klucz',
      dataDescription: 'O co zapytać',
      active: 'Aktywny',
    },
    help: {
      objective: 'Co agent ma osiągnąć w rozmowie.',
      openingLine: 'Pierwsze zdanie agenta. Puste = agent przedstawi się sam.',
      guardrails: 'Czego agentowi nie wolno, po jednej zasadzie w wierszu.',
      dataToCollect: 'Najwyżej {{max}} pola. Klucz trafia do wyniku rozmowy i eksportu CSV.',
    },
    addGuardrail: 'Dodaj zasadę',
    addDataKey: 'Dodaj pole',
    removeRow: 'Usuń wiersz {{index}}',
    validation: {
      nameRequired: 'Podaj nazwę scenariusza',
      objectiveRequired: 'Opisz cel rozmowy',
      successCriteriaRequired: 'Opisz kryterium sukcesu',
      guardrailRequired: 'Wpisz zasadę albo usuń wiersz',
      dataKeyRequired: 'Podaj klucz',
      dataKeyFormat: 'Litery, cyfry i _, bez spacji, zaczyna się od litery',
      dataKeyDuplicate: 'Ten klucz już jest',
      nameTaken: 'Scenariusz o tej nazwie już istnieje',
    },
    saveFailed: 'Nie udało się zapisać scenariusza',
  },

  testCall: {
    title: 'Rozmowa testowa',
    subtitle: 'Scenariusz „{{name}}”, poza kampanią.',
    warning: 'To prawdziwe połączenie: agent zadzwoni od razu pod podany numer.',
    phone: 'Numer telefonu',
    phoneRequired: 'Podaj numer',
    phoneInvalid: 'Numer musi zaczynać się od +48 albo +1',
    language: 'Język rozmowy',
    openingLine: 'Otwarcie (opcjonalnie)',
    call: 'Zadzwoń',
    placed: 'Dzwonię. Rozmowa pojawi się w historii rozmów.',
    errors: {
      invalid_params: 'Sprawdź pola formularza',
      scenario_not_found: 'Scenariusz nie istnieje albo jest wyłączony',
      language_not_supported: 'Firma nie ma głosu w tym języku',
      twilio_rejected: 'Operator odrzucił połączenie',
      outbound_rejected: 'Nie można zadzwonić',
    },
  },

  calls: {
    searchPlaceholder: 'Szukaj firmy lub numeru',
    allScenarios: 'Wszystkie scenariusze',
    allCampaigns: 'Wszystkie kampanie',
    allDispositions: 'Każdy wynik',
    allSources: 'Każde źródło',
    anyObjective: 'Cel: wszystkie',
    empty: 'Brak rozmów wychodzących.',
    columns: {
      date: 'Data',
      callee: 'Rozmówca',
      scenario: 'Scenariusz',
      source: 'Źródło',
      outcome: 'Wynik',
      transfer: 'Przekazanie',
      duration: 'Czas',
    },
  },

  salespeople: {
    add: 'Dodaj sprzedawcę',
    empty: 'Nie ma jeszcze sprzedawców.',
    hint: 'Agent przekazuje rozmowę dostępnemu sprzedawcy. Kampania dzwoni tylko wtedy, gdy co najmniej jeden jest dostępny.',
    columns: {
      name: 'Sprzedawca',
      phone: 'Numer',
      status: 'Status',
      available: 'Dostępny',
      hours: 'Godziny pracy',
      changedAt: 'Zmiana statusu',
    },
    outsideHours: 'poza godzinami pracy',
    availableUntil: 'do {{at}}',
    allTheTime: 'Bez ograniczeń',
    everyDay: 'codziennie',
    hoursValue: '{{days}}, {{start}}–{{end}}',
    daysOnly: '{{days}}, cały dzień',
    noAccount: 'bez konta w panelu',
    toggle: 'Dostępność: {{name}}',
    edit: 'Edytuj {{name}}',
    delete: 'Usuń {{name}}',
    deleteTitle: 'Usuń sprzedawcę',
    deleteContent: 'Czy na pewno usunąć sprzedawcę {{name}}? Tej operacji nie można cofnąć.',
    form: {
      createTitle: 'Nowy sprzedawca',
      editTitle: 'Edytuj sprzedawcę',
      subtitle: 'Numer, pod który agent przekaże rozmowę, i godziny, w których można go łączyć.',
      name: 'Imię i nazwisko',
      nameRequired: 'Podaj imię i nazwisko',
      phone: 'Numer telefonu',
      phoneRequired: 'Podaj numer',
      phoneInvalid: 'Numer musi zaczynać się od +48 albo +1',
      phoneTaken: 'Ten numer ma już inny sprzedawca',
      workDays: 'Dni pracy',
      workDaysHelp: 'Bez zaznaczonych dni: codziennie.',
      workHours: 'Godziny pracy',
      workHoursHelp: 'Czas firmy. Puste = cały dzień; „dostępny” wyłącza się sam o 20:00.',
      workStart: 'Od',
      workEnd: 'Do',
      account: 'Konto w panelu',
      accountHelp: 'Właściciel konta przełącza swoją dostępność w nagłówku panelu.',
      accountNone: 'Bez konta',
      accountMine: 'Moje konto ({{email}})',
      saveFailed: 'Nie udało się zapisać sprzedawcy',
    },
  },

  // Przełącznik w nagłówku dla zalogowanego sprzedawcy.
  myAvailability: {
    label: 'Moja dostępność',
    available: 'Dostępny',
    offline: 'Niedostępny',
    busy: 'W rozmowie',
    failed: 'Nie udało się zmienić dostępności',
  },
} as const;
